import styled from 'styled-components'
import { colors } from '../../lib/colors'

// interface CARD_PROPS {
//   isBack?: boolean
//   animDelay?:number
// }

export const GameBoardContainer = styled.div`
  width: 100%;
`
export const Placeholder = styled.div<{ zIndex?: number }>`
  position: relative;
  width: 55px;
  height: 80px;
  text-align: center;
  background: ${colors.primaryLight};
  border-radius: 8px;
  z-index: ${({ zIndex }) => zIndex};
  .back,
  .front {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden; /* Safari */
    backface-visibility: hidden;
    border-radius: 8px;
  }
  .front {
    z-index: 99;
  }
`
export const PlaceholderWrapper = styled.div<{ noAnimate?: boolean }>`
  display: flex;
  justify-content: center;
  div:first-child {
    margin-right: 10px;
  }
  &.dealer {
    margin-bottom: 10px;
    margin-top: ${({ noAnimate }) => (noAnimate ? '30px' : '35px')};
  }
  &.player {
    margin-bottom: 25px;
  }
`
export const RiverWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`
